export default __webpack_public_path__ + "images/21429de5cd082b33a1efca4206ee2a46-national_security_small.webp";